<span class="kt-font-danger" *ngIf="status === 1"> Not Started </span>
<span class="kt-font-primary" *ngIf="status === 2"> In Progress </span>
<span class="kt-font-warning" *ngIf="status === 3"> On Hold </span>
<span class="kt-font-success" *ngIf="status === 4"> Closed </span>